import { cn } from "@/util/cn";
import type { VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import { Slot as SlotPrimitive } from "radix-ui";
import type * as React from "react";
import { buttonVariants } from "./button";

export type LoadingButtonProps = {
    asChild?: boolean;
    loading?: boolean;
} & React.ComponentProps<"button"> &
    VariantProps<typeof buttonVariants>;

export const LoadingButton = ({
    className,
    variant,
    size,
    children,
    loading,
    disabled,
    asChild = false,
    ...props
}: LoadingButtonProps) => {
    const Comp = asChild ? SlotPrimitive.Slot : "button";
    return (
        <Comp
            className={cn(buttonVariants({ variant, size, className }))}
            disabled={loading === true || disabled === true}
            {...props}
        >
            {loading === true && <Loader2 className="animate-spin" />} {children}
        </Comp>
    );
};
